<div class="progress-bar-container" prlwResponsive>
  <div
    class="progress-bar"
    [style.width]="calculateProgressPercent + '%'"
  ></div>
</div>
